import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";
import { AppErrorBoundary } from "@/components/ui/error-boundary";

const StatsView = lazy(async () => {
  const m = await import("@/features/habits/components/stats-view");
  return { default: m.StatsView };
});

/** Statistics: % completion, streaks, and totals per habit. */
function StatsPage() {
  return (
    // Regional boundary: the analytics view does the heaviest derivation/SVG
    // work, so an error here degrades to an inline fallback without blanking
    // the whole shell (header/sidebar/swipe stay alive).
    <AppErrorBoundary variant="region" region="stats">
      <Suspense fallback={null}>
        <StatsView />
      </Suspense>
    </AppErrorBoundary>
  );
}

export const statsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/stats",
  component: StatsPage,
});
